<template>
    <div class="e-loader">
        <div class="e-loader__cont">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
export default {}
</script>
